// account
export const SIGNUP_URL = '/auth/signup';
export const SIGNUP_OAUTH_URL = '/auth/signupOAuth';
export const LOGIN_URL = '/auth/login';
export const LOGIN_OAUTH_URL = '/auth/loginOAuth';
export const FORGOT_PASSWORD_URL = '/auth/forgotPassword';
export const RESET_PASSWORD = '/auth/resetPassword';
export const RESET_PASSWORD_AUTHED_URL = '/auth/resetPasswordAuthed';
export const SET_PASSWORD_AND_VERIFY_URL = '/auth/setPasswordAndVerify';
export const REQUEST_SET_PASSWORD_AND_VERIFY_URL =
  '/auth/requestSetPasswordAndVerifyLink';
export const REQUEST_EMAIL_VERIFICATION = '/auth/requestEmailVerificationLink';
export const VERIFY_EMAIL_URL = '/auth/verifyEmail';

// user
export const GET_USER_URL = '/user';
export const REGISTER_USER_URL = '/user';
export const EDIT_USER_URL = '/user';
export const TOGGLE_USER_IS_ACTIVE_URL = '/user/isActive';
export const DELETE_USER_URL = '/user';

// organization
export const GET_ORGANIZATION_URL = '/organization';
export const GET_ORGANIZATION_STATS_URL = '/organization/stats';
export const REGISTER_ORGANIZATION_URL = '/organization';
export const SIGNUP_ORGANIZATION_URL = '/organization/signup';
export const EDIT_ORGANIZATION_URL = '/organization';
export const EDIT_YURTZEITEN_DISPLAY_URL = '/organization/yurtzeiten-display';
export const TOGGLE_ORGANIZATION_IS_ACTIVE_URL = '/organization/isActive';
export const DELETE_ORGANIZATION_URL = '/organization';

// donation
export const GET_DONATION_URL = '/donation';
export const REGISTER_DONATION_URL = '/donation';
export const EDIT_DONATION_URL = '/donation';
export const TOGGLE_DONATION_IS_ACTIVE_URL = '/donation/isActive';
export const MOVE_DONATION_TO_FOLDER_URL = '/donation/folder';
export const BULK_MOVE_DONATIONS_TO_FOLDER_URL = '/donation/bulk/folder';
export const DELETE_DONATION_URL = '/donation';
export const BULK_DELETE_DONATIONS_URL = '/donation/bulk';

// folder
export const GET_FOLDER_URL = '/folder';
export const REGISTER_FOLDER_URL = '/folder';
export const EDIT_FOLDER_URL = '/folder';
export const DELETE_FOLDER_URL = '/folder';

// announcement
export const GET_ANNOUNCEMENT_URL = '/announcement';
export const REGISTER_ANNOUNCEMENT_URL = '/announcement';
export const EDIT_ANNOUNCEMENT_URL = '/announcement';
export const TOGGLE_ANNOUNCEMENT_IS_ACTIVE_URL = '/announcement/isActive';
export const MOVE_ANNOUNCEMENT_TO_FOLDER_URL = '/announcement/folder';
export const BULK_MOVE_ANNOUNCEMENTS_TO_FOLDER_URL = '/announcement/bulk/folder';
export const DELETE_ANNOUNCEMENT_URL = '/announcement';
export const BULK_DELETE_ANNOUNCEMENTS_URL = '/announcement/bulk';

// template
export const GET_TEMPLATE_URL = '/template';
export const REGISTER_TEMPLATE_URL = '/template';
export const EDIT_TEMPLATE_URL = '/template';
export const TOGGLE_TEMPLATE_IS_ACTIVE_URL = '/template/isActive';
export const DELETE_TEMPLATE_URL = '/template';

// screen
export const GET_SCREEN_URL = '/screen';
export const GET_SCREEN_UNPOPULATED_URL = '/screen/unpopulated';
export const REGISTER_SCREEN_URL = '/screen';
export const REFRESH_SCREEN_URL = '/screen/refresh';
export const EDIT_SCREEN_URL = '/screen';
export const TOGGLE_SCREEN_IS_ACTIVE_URL = '/screen/isActive';
export const DELETE_SCREEN_URL = '/screen';

// screen_schedule — switching schedules and the public link that plays them
export const SCREEN_SCHEDULE_URL = '/screenSchedule';
export const SCREEN_SCHEDULE_BY_SCREEN_URL = '/screenSchedule/screen';
export const PUBLIC_SCREEN_SCHEDULE_URL = '/screenSchedule/public';

// yurtzeiten
export const GET_YURTZEITEN_URL = '/yurtzeiten';
export const REGISTER_YURTZEITEN_URL = '/yurtzeiten';
export const EDIT_YURTZEITEN_URL = '/yurtzeiten';
export const TOGGLE_YURTZEITEN_IS_ACTIVE_URL = '/yurtzeiten/isActive';
export const DELETE_YURTZEITEN_URL = '/yurtzeiten';

// yurtzeiten_template
export const GET_YURTZEITEN_TEMPLATE_URL = '/yurtzeitenTemplate';
export const REGISTER_YURTZEITEN_TEMPLATE_URL = '/yurtzeitenTemplate';
export const EDIT_YURTZEITEN_TEMPLATE_URL = '/yurtzeitenTemplate';
export const TOGGLE_YURTZEITEN_TEMPLATE_IS_ACTIVE_URL = '/yurtzeitenTemplate/isActive';
export const DELETE_YURTZEITEN_TEMPLATE_URL = '/yurtzeitenTemplate';

// yurtzeiten_email_template
export const GET_YURTZEITEN_EMAIL_TEMPLATE_URL = '/yurtzeitenEmailTemplate';
export const REGISTER_YURTZEITEN_EMAIL_TEMPLATE_URL = '/yurtzeitenEmailTemplate';
export const EDIT_YURTZEITEN_EMAIL_TEMPLATE_URL = '/yurtzeitenEmailTemplate';
export const TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_ACTIVE_URL = '/yurtzeitenEmailTemplate/isActive';
export const TOGGLE_YURTZEITEN_EMAIL_TEMPLATE_IS_DEFAULT_URL = '/yurtzeitenEmailTemplate/isDefault';
export const CHANGE_YURTZEITEN_EMAIL_TEMPLATE_CATEGORY_URL = '/yurtzeitenEmailTemplate/category';
export const DELETE_YURTZEITEN_EMAIL_TEMPLATE_URL = '/yurtzeitenEmailTemplate';

// setting
export const GET_SETTING_URL = '/setting';
export const REGISTER_SETTING_URL = '/setting';
export const EDIT_SETTING_URL = '/setting';
export const TOGGLE_SETTING_IS_ACTIVE_URL = '/setting/isActive';
export const DELETE_SETTING_URL = '/setting';

// recentPhoto
export const GET_RECENT_PHOTO_URL = '/recentPhoto';
export const REGISTER_RECENT_PHOTO_URL = '/recentPhoto';
export const EDIT_RECENT_PHOTO_URL = '/recentPhoto';
export const TOGGLE_RECENT_PHOTO_IS_ACTIVE_URL = '/recentPhoto/isActive';
export const DELETE_RECENT_PHOTO_URL = '/recentPhoto';

// event
export const GET_EVENT_URL = '/event';
export const REGISTER_EVENT_URL = '/event';
export const EDIT_EVENT_URL = '/event';
export const TOGGLE_EVENT_IS_ACTIVE_URL = '/event/isActive';
export const DELETE_EVENT_URL = '/event';

// event template
export const GET_EVENT_TEMPLATE_URL = '/eventTemplate';
export const REGISTER_EVENT_TEMPLATE_URL = '/eventTemplate';
export const EDIT_EVENT_TEMPLATE_URL = '/eventTemplate';
export const TOGGLE_EVENT_TEMPLATE_IS_ACTIVE_URL = '/eventTemplate/isActive';
export const DELETE_EVENT_TEMPLATE_URL = '/eventTemplate';

// weeklyEvent
export const GET_WEEKLY_EVENT_URL = '/weeklyEvent';
export const REGISTER_WEEKLY_EVENT_URL = '/weeklyEvent';
export const EDIT_WEEKLY_EVENT_URL = '/weeklyEvent';
export const DELETE_WEEKLY_EVENT_URL = '/weeklyEvent';

// weeklySchedule_N — the Weekly Schedule engine (one bundle in, granular writes out)
// The organization's weekly schedules, each summed up for its card.
export const WEEKLY_SCHEDULE_N_URL = '/weeklySchedule_N';
// One schedule: GET /:id is its whole bundle; POST, PUT and DELETE /:id manage it.
export const WEEKLY_SCHEDULE_N_SCHEDULE_URL = '/weeklySchedule_N/schedule';
export const WEEKLY_SCHEDULE_N_SCHEDULE_TOGGLE_URL = '/weeklySchedule_N/schedule/isActive';
export const WEEKLY_SCHEDULE_N_SCHEDULE_DUPLICATE_URL = '/weeklySchedule_N/schedule/duplicate';
// Unauthenticated: what a public screen reads for itself.
export const WEEKLY_SCHEDULE_N_PUBLIC_URL = '/weeklySchedule_N/public';
export const WEEKLY_SCHEDULE_N_TEMPLATE_URL = '/weeklySchedule_N/template';
export const WEEKLY_SCHEDULE_N_TEMPLATE_ACTIVATE_URL = '/weeklySchedule_N/template/activate';
export const WEEKLY_SCHEDULE_N_TEMPLATE_DUPLICATE_URL = '/weeklySchedule_N/template/duplicate';
export const WEEKLY_SCHEDULE_N_ITEM_URL = '/weeklySchedule_N/item';
export const WEEKLY_SCHEDULE_N_ITEM_DUPLICATE_URL = '/weeklySchedule_N/item/duplicate';
export const WEEKLY_SCHEDULE_N_ITEM_COPY_DAY_URL = '/weeklySchedule_N/item/copy-day';
export const WEEKLY_SCHEDULE_N_ITEM_VERIFY_URL = '/weeklySchedule_N/item/verify';
export const WEEKLY_SCHEDULE_N_OVERRIDE_URL = '/weeklySchedule_N/override';
export const WEEKLY_SCHEDULE_N_DAY_NOTE_URL = '/weeklySchedule_N/day-note';
export const WEEKLY_SCHEDULE_N_DISPLAY_URL = '/weeklySchedule_N/display';
export const WEEKLY_SCHEDULE_N_SETTINGS_URL = '/weeklySchedule_N/settings';

// photoUnderline
export const GET_PHOTO_UNDERLINE_URL = '/photoUnderline';
export const REGISTER_PHOTO_UNDERLINE_URL = '/photoUnderline';
export const EDIT_PHOTO_UNDERLINE_URL = '/photoUnderline';
export const TOGGLE_PHOTO_UNDERLINE_IS_ACTIVE_URL = '/photoUnderline/isActive';
export const DELETE_PHOTO_UNDERLINE_URL = '/photoUnderline';

// minyanim
export const GET_MINYANIM_URL = '/minyanim';
export const REGISTER_MINYANIM_URL = '/minyanim';
export const EDIT_MINYANIM_URL = '/minyanim';
export const SYNC_MINYANIM_URL = '/minyanim/sync';
export const TOGGLE_MINYANIM_IS_ACTIVE_URL = '/minyanim/isActive';
export const DELETE_MINYANIM_URL = '/minyanim';

// minyanim_type
export const GET_MINYANIM_TYPE_URL = '/minyanimType';
export const REGISTER_MINYANIM_TYPE_URL = '/minyanimType';
export const EDIT_MINYANIM_TYPE_URL = '/minyanimType';
export const TOGGLE_MINYANIM_TYPE_IS_ACTIVE_URL = '/minyanimType/isActive';
export const DELETE_MINYANIM_TYPE_URL = '/minyanimType';

// zmanim
export const GET_ZMANIM_URL = '/zmanim';
export const REGISTER_ZMANIM_URL = '/zmanim';
export const EDIT_ZMANIM_URL = '/zmanim';
export const TOGGLE_ZMANIM_IS_ACTIVE_URL = '/zmanim/isActive';
export const DELETE_ZMANIM_URL = '/zmanim';

// ticket
export const TICKET_URL = '/ticket'
export const ADD_TICKET_URL = '/ticket/add'
export const EDIT_TICKET_URL = '/ticket/edit'
export const CLOSE_TICKET_URL = '/ticket/close'
export const DELETE_TICKET_URL = '/ticket'
export const TICKET_UNREAD_URL = '/ticket/unread'

// ticket_comment
export const TICKET_COMMENT_URL = '/ticketComment'
export const ADD_TICKET_COMMENT_URL = '/ticketComment/add'
export const EDIT_TICKET_COMMENT_URL = '/ticketComment/edit'
export const DELETE_TICKET_COMMENT_URL = '/ticketComment'

// date_time_banner
export const GET_DATE_TIME_BANNER_URL = '/dateTimeBanner';
export const REGISTER_DATE_TIME_BANNER_URL = '/dateTimeBanner';
export const EDIT_DATE_TIME_BANNER_URL = '/dateTimeBanner';
export const TOGGLE_DATE_TIME_BANNER_IS_ACTIVE_URL = '/dateTimeBanner/isActive';
export const DELETE_DATE_TIME_BANNER_URL = '/dateTimeBanner';
// zmanim_N
export const GET_ZMANIM_N_URL = '/zmanim_N';
export const REGISTER_ZMANIM_N_URL = '/zmanim_N';
export const EDIT_ZMANIM_N_URL = '/zmanim_N';
export const TOGGLE_ZMANIM_N_IS_ACTIVE_URL = '/zmanim_N/isActive';
export const DELETE_ZMANIM_N_URL = '/zmanim_N';

// screen_artboard
export const GET_SCREEN_ARTBOARD_URL = '/screenArtboard';
export const GET_SCREEN_ARTBOARD_CONTENT_URL = '/screenArtboard/content';
export const REGISTER_SCREEN_ARTBOARD_URL = '/screenArtboard';
export const EDIT_SCREEN_ARTBOARD_URL = '/screenArtboard';
export const TOGGLE_SCREEN_ARTBOARD_IS_ACTIVE_URL = '/screenArtboard/isActive';
export const DELETE_SCREEN_ARTBOARD_URL = '/screenArtboard';

// yurtzeiten_N
export const GET_YURTZEITEN_N_URL = '/yurtzeiten_N';
export const GET_YURTZEITEN_N_DISPLAY_URL = '/yurtzeiten_N/display';
// Server-side counts per status, for the submission tab bubbles.
export const GET_YURTZEITEN_N_STATS_URL = '/yurtzeiten_N/stats';
export const REGISTER_YURTZEITEN_N_URL = '/yurtzeiten_N';
export const IMPORT_YURTZEITEN_N_URL = '/yurtzeiten_N/import';
export const EDIT_YURTZEITEN_N_URL = '/yurtzeiten_N';
export const TOGGLE_YURTZEITEN_N_IS_ACTIVE_URL = '/yurtzeiten_N/isActive';
// Unauthenticated: the endpoint the public yahrzeit form posts to.
export const SUBMIT_PUBLIC_YURTZEITEN_N_URL = '/yurtzeiten_N/public';
export const APPROVE_YURTZEITEN_N_URL = '/yurtzeiten_N/approve';
export const REJECT_YURTZEITEN_N_URL = '/yurtzeiten_N/reject';
export const MARK_VIEWED_YURTZEITEN_N_URL = '/yurtzeiten_N/viewed';
export const DELETE_YURTZEITEN_N_URL = '/yurtzeiten_N';

// yurtzeiten_N design — one org-wide row, so the save is a single PUT that the
// server turns into an insert or an update.
export const GET_YURTZEITEN_DESIGN_N_URL = '/yurtzeitenDesign_N';
export const SAVE_YURTZEITEN_DESIGN_N_URL = '/yurtzeitenDesign_N';
// Images dropped into the design editor are uploaded up front, so the saved
// design only ever carries a URL.
export const UPLOAD_YURTZEITEN_DESIGN_IMAGE_N_URL = '/yurtzeitenDesign_N/image';

// zmanim display override N
export const GET_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';
export const REGISTER_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';
export const EDIT_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';
export const TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE_URL = '/zmanimDisplayOverride_N/isActive';
export const DELETE_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';

// room
export const GET_ROOM_URL = '/room';
export const REGISTER_ROOM_URL = '/room';
export const EDIT_ROOM_URL = '/room';
export const TOGGLE_ROOM_IS_ACTIVE_URL = '/room/isActive';
export const DELETE_ROOM_URL = '/room';

// minyan_roll_N
export const GET_MINYAN_ROLL_N_URL = '/minyanRoll_N';
export const REGISTER_MINYAN_ROLL_N_URL = '/minyanRoll_N';
export const EDIT_MINYAN_ROLL_N_URL = '/minyanRoll_N';
export const TOGGLE_MINYAN_ROLL_N_IS_ACTIVE_URL = '/minyanRoll_N/isActive';
export const DELETE_MINYAN_ROLL_N_URL = '/minyanRoll_N';

// minyan_N
export const GET_MINYAN_N_URL = '/minyan_N';
export const REGISTER_MINYAN_N_URL = '/minyan_N';
export const EDIT_MINYAN_N_URL = '/minyan_N';
export const TOGGLE_MINYAN_N_IS_ACTIVE_URL = '/minyan_N/isActive';
export const DELETE_MINYAN_N_URL = '/minyan_N';

// custom_font
export const GET_CUSTOM_FONT_URL = '/customFont';
export const REGISTER_CUSTOM_FONT_URL = '/customFont';
export const EDIT_CUSTOM_FONT_URL = '/customFont';
export const DELETE_CUSTOM_FONT_URL = '/customFont';
